import { SiteUtilities } from './utils';

const pricingData = function (isLocalPricing, country, countryName) {
  var jsonData;
  var selectedCountry;
  /*
   * jsonUrls are urls of json data for each product pricing.
  */
  var jsonUrls = {
    fworks: '/static-assets/js/pricing-fworks.json',
    fdesk: '/static-assets/js/pricing-fdesk.json',
    fcaller: '/static-assets/js/pricing-fcaller.json',
    fsales: '/static-assets/js/pricing-fsales.json',
    fservice: '/static-assets/js/pricing-fservice.json',
    fteam: '/static-assets/js/pricing-fteam.json',
    fchat: '/static-assets/js/pricing-fchat.json'
  };
  /*
   * Appending time to the json because json assets are usually cached in s3 and are not hashed.
  */
  var dateObject = new Date();
  var timeStamp = dateObject.getDate() + '' + dateObject.getMonth() + '' + dateObject.getFullYear();
  /*
   * producKey is to get the product name from pricing-table
   * page. Product name is set in 'data-product' attribute
   * in pricing-table class element.
  */
  var productKey = jQuery('.pricing-table').attr('data-product');
  if (!jsonUrls[productKey]) {
    return;
  }
  const regionCode = country;

  jQuery.getJSON(jsonUrls[productKey] + `?t=${timeStamp}&v=1.9`, function (json) {
    jsonData = json;
    selectedCountry = SiteUtilities.selectCountry(jsonData, regionCode, countryName);
    var pricingSymbol = jsonData[selectedCountry];
    const $addonPricingColumn = $('.pricing-table-wide-column');

    // Freshdesk addon pricing <---start---->
    if ($addonPricingColumn.length && $addonPricingColumn.find('.pricing-currency-symbol').length) {
      $addonPricingColumn.find('.pricing-currency-symbol').html(pricingSymbol.symbol);
      $addonPricingColumn.find('.plan-price.odometer-auto-theme').html(jsonData[selectedCountry].addon_price);
    }
    // Freshdesk addon pricing <---end---->
    // for lengthy currencies, we add an extra class to
    // adjust the styling to accommodate the extra characters
    if (pricingSymbol['symbol'].length > 1) {
      jQuery('.pricing-currency-symbol').addClass('long-currency');
    }
    jQuery('.pricing-currency-symbol').html(pricingSymbol.symbol);

    // setting omnichanel agent prcing
    if (productKey === 'fdesk' && jQuery('.omnichannel-header').length > 0) {
      var country = jsonData[selectedCountry];
      var pricing = [country['sprout_omni_agent'], country['blossom_omni_agent'], country['garden_omni_agent'], country['estate_omni_agent'], country['forest_omni_agent']];
      jQuery('.agent-pricing').each(function (ind, val) {
        var price = typeof (pricing[ind]) === 'string' ? pricing[ind] : '+' + ' ' + country.symbol + ' ' + pricing[ind];
        jQuery(val).html(price);
      });
    }
    /*
    * Setting currency symbol if page head-banner
    * has local currency symbols.
    */
    if (jQuery('.banner-currency-symbol').length > 0) {
      // for now its only for fservice
      if (productKey === 'fservice' && jsonData[selectedCountry]['blossom_annual']) {
        jQuery('.banner-currency-symbol').html(pricingSymbol['symbol']);
        jQuery('.banner-currency-price').html(jsonData[selectedCountry]['blossom_annual']);
      }
    }
    /*
    * adding additional asset cost for fsercice pricing page
    * if pricing.json has key 'additional_asset'
    */
    if (jsonData[selectedCountry]['additional_asset_cost']) {
      jQuery('.additional-asset-cost').html(jsonData[selectedCountry]['symbol'] + ' ' + jsonData[selectedCountry]['additional_asset_cost']);
    }
    /*
    * if user country is Australia we need to show a meesage
    * saying that "All prices mentioned are in AUD."
    */
    const pricingBottomInfoElement = jQuery('.vertical-tab-pricing-wrapper').length ? '.vertical-tab-pricing-wrapper' : '.pricing-table';
    if (selectedCountry === 'IN') {
      const $pricingTable = jQuery('.pricing-table');
      const disclaimerTextForIndia = $pricingTable.data('disclaimer-india') && $pricingTable.data('disclaimer-india').length ? $pricingTable.data('disclaimer-india') : 'INR pricing is for online payments only. For offline payment, please follow USD pricing.';
      jQuery('.pricing-table-info').remove();
      jQuery(`<div class="pricing-table-info"><p>${disclaimerTextForIndia}</p></div>`).insertAfter(pricingBottomInfoElement);
    }
    /*
    * if user country is South America we need to show a meesage
    * saying that "This is a discounted price for your region..."
    */
    if (productKey === 'fservice' && selectedCountry === 'SOUTH-AMERICA') {
      jQuery('<div class="pricing-table-info"><p>This is a discounted price for your region. The price inside the product might be a little different. Please contact your account manager or support to avail this price.</p></div>').insertAfter(pricingBottomInfoElement);
    }
    /*
     * This if condition checks pricing_switch [input] is checked or
     * not by default. If checked its updated annual price based on
     * the country.
    */
    if (jQuery('input#pricing_switch').length !== 0) {
      if (jQuery('input#pricing_switch').is(':checked')) {
        setClassForYearly();
        priceYearly();
      } else {
        setClassForMonthly();
        priceMonthly();
      }
    } else {
      setClassForYearly();
      priceYearly();
    }
    /*
    * Calling additional asset cost card function
    * to update additional asset cost card.
    */
    additionalAsseetCostCard();
    const countries = jsonData[selectedCountry];
    jQuery('.monthly-pricing').each(function (index, elem) {
      const planName = jQuery(elem).data('plan');
      let price = countries.symbol + 0;
      if (planName !== 'sprout') {
        price = countries.symbol + formatCurrency(countries[`${planName}_monthly`], selectedCountry);
      }
      jQuery(elem).text(price);
    });

    jQuery('.monthly-pricing-omnichannel').each(function (index, elem) {
      const planName = jQuery(elem).data('plan');
      const price = countries.symbol + formatCurrency(countries[`${planName}_omni_monthly`], selectedCountry);
      jQuery(elem).text(price);
    });

    jQuery('.plan-price-before').each(function (index, elem) {
      const planName = jQuery(elem).data('plan');
      if (countries[`${planName}_omni_annual_discount`]) {
        jQuery(elem).find('.currency-symbol').text(countries.symbol);
        if (countries.symbol.length > 1) {
          jQuery(elem).find('.currency-symbol').addClass('long-currency');
        }
        jQuery(elem).find('.price-before-discount').text(formatCurrency(countries[`${planName}_omni_annual_discount`], selectedCountry));
      } else {
        jQuery(elem).hide();
      }
    });
  });

  var blossomOdometers = document.querySelector('#blossom_odometers');
  var gardenOdometers = document.querySelector('#garden_odometers');
  var estateOdometers = document.querySelector('#estate_odometers');
  var forestOdometers = document.querySelector('#forest_odometers');

  var starterOdometers = document.querySelector('#starter_odometers');
  var growthOdometers = document.querySelector('#growth_odometers');
  var proOdometers = document.querySelector('#pro_odometers');
  var enterpriseOdometers = document.querySelector('#enterprise_odometers');

  const blossomOmniOdometers = document.querySelector('#blossom_omni_odometers');
  const gardenOmniOdometers = document.querySelector('#garden_omni_odometers');
  const estateOmniOdometers = document.querySelector('#estate_omni_odometers');
  const forestOmniOdometers = document.querySelector('#forest_omni_odometers');

  var starterOmniOdometers = document.querySelector('#starter_omni_odometers');
  var growthOmniOdometers = document.querySelector('#growth_omni_odometers');
  var proOmniOdometers = document.querySelector('#pro_omni_odometers');
  var enterpriseOmniOdometers = document.querySelector('#enterprise_omni_odometers');
  var countryPricing;

  function setClassForMonthly () {
    jQuery('.pricing-package').removeClass('active');
    jQuery('.pricing-monthly').addClass('active');
  }
  function setClassForYearly () {
    jQuery('.pricing-package').removeClass('active');
    jQuery('.pricing-yearly').addClass('active');
  }

  function priceYearly () {
    countryPricing = jsonData[selectedCountry];
    var isFteam = jQuery('body').attr('data-product-name') === 'fteam';
    var employeeCount = {};
    if (isFteam) {
      const planInput = jQuery('.pricing-table-column .plan-input');
      employeeCount.blossom = +(planInput.eq(0).attr('data-employees-count')) || 1;
      employeeCount.garden = +(planInput.eq(1).attr('data-employees-count')) || 1;
      employeeCount.estate = +(planInput.eq(2).attr('data-employees-count')) || 1;
    }
    if (blossomOdometers != null) {
      blossomOdometers.innerHTML = isFteam ? (countryPricing.blossom_annual) * (employeeCount.blossom) : countryPricing.blossom_annual;
    }
    if (gardenOdometers != null) {
      gardenOdometers.innerHTML = isFteam ? (countryPricing.garden_annual) * (employeeCount.garden) : countryPricing.garden_annual;
    }
    if (estateOdometers != null) {
      estateOdometers.innerHTML = isFteam ? (countryPricing.estate_annual) * (employeeCount.estate) : countryPricing.estate_annual;
    }
    if (forestOdometers != null) {
      forestOdometers.innerHTML = countryPricing.forest_annual;
    }

    if (starterOdometers != null) {
      starterOdometers.innerHTML = countryPricing.starter_annual;
    }
    if (growthOdometers != null) {
      growthOdometers.innerHTML = countryPricing.growth_annual;
    }
    if (proOdometers != null) {
      proOdometers.innerHTML = countryPricing.pro_annual;
    }
    if (enterpriseOdometers != null) {
      enterpriseOdometers.innerHTML = countryPricing.enterprise_annual;
    }

    jQuery('.agents-billed-period').removeClass('monthly');

    var monthlyPrices = [countryPricing.blossom_monthly, countryPricing.garden_monthly, countryPricing.estate_monthly];

    if (jQuery('.annual-pricing-value')) {
      jQuery('.annual-pricing-value').each(function (ind, val) {
        jQuery(val).html(countryPricing.symbol + monthlyPrices[ind]);
      });
    }

    if (blossomOmniOdometers && countryPricing.blossom_omni_annual) {
      blossomOmniOdometers.innerText = countryPricing.blossom_omni_annual;
    }
    if (gardenOmniOdometers && countryPricing.garden_omni_annual) {
      gardenOmniOdometers.innerText = countryPricing.garden_omni_annual;
    }
    if (estateOmniOdometers && countryPricing.estate_omni_annual) {
      estateOmniOdometers.innerText = countryPricing.estate_omni_annual;
    }
    if (forestOmniOdometers && countryPricing.forest_omni_annual) {
      forestOmniOdometers.innerText = countryPricing.forest_omni_annual;
    }

    if (starterOmniOdometers && countryPricing.starter_omni_annual) {
      starterOmniOdometers.innerText = countryPricing.starter_omni_annual;
    }
    if (growthOmniOdometers && countryPricing.growth_omni_annual) {
      growthOmniOdometers.innerText = countryPricing.growth_omni_annual;
    }
    if (proOmniOdometers && countryPricing.pro_omni_annual) {
      proOmniOdometers.innerText = countryPricing.pro_omni_annual;
    }
    if (enterpriseOmniOdometers && countryPricing.enterprise_omni_annual) {
      enterpriseOmniOdometers.innerText = countryPricing.enterprise_omni_annual;
    }
  }
  function priceMonthly () {
    countryPricing = jsonData[selectedCountry];
    var isFteam = jQuery('body').attr('data-product-name') === 'fteam';
    var employeeCount = {};
    if (isFteam) {
      const planInput = jQuery('.pricing-table-column .plan-input');
      employeeCount.blossom = +(planInput.eq(0).attr('data-employees-count')) || 1;
      employeeCount.garden = +(planInput.eq(1).attr('data-employees-count')) || 1;
      employeeCount.estate = +(planInput.eq(2).attr('data-employees-count')) || 1;
    }
    if (blossomOdometers != null) {
      blossomOdometers.innerHTML = isFteam ? (countryPricing.blossom_monthly) * (employeeCount.blossom) : countryPricing.blossom_monthly;
    }
    if (gardenOdometers != null) {
      gardenOdometers.innerHTML = isFteam ? (countryPricing.garden_monthly) * (employeeCount.garden) : countryPricing.garden_monthly;
    }
    if (estateOdometers != null) {
      estateOdometers.innerHTML = isFteam ? (countryPricing.estate_monthly) * (employeeCount.estate) : countryPricing.estate_monthly;
    }
    if (forestOdometers != null) {
      forestOdometers.innerHTML = countryPricing.forest_monthly;
    }
    if (starterOdometers != null) {
      starterOdometers.innerHTML = countryPricing.starter_monthly;
    }
    if (growthOdometers != null) {
      growthOdometers.innerHTML = countryPricing.growth_monthly;
    }
    if (proOdometers != null) {
      proOdometers.innerHTML = countryPricing.pro_monthly;
    }
    if (enterpriseOdometers != null) {
      enterpriseOdometers.innerHTML = countryPricing.enterprise_monthly;
    }
    jQuery('.agents-billed-period').addClass('monthly');
    if (isFteam) {
      jQuery('.pricing-table-column .plan-input').eq(0).attr('data-plan-cost-monthly', countryPricing.blossom_monthly);
      jQuery('.pricing-table-column .plan-input').eq(1).attr('data-plan-cost-monthly', countryPricing.garden_monthly);
      jQuery('.pricing-table-column .plan-input').eq(2).attr('data-plan-cost-monthly', countryPricing.estate_monthly);
    }
  }

  jQuery('.pricing-toggle-button').on('click', function () {
    if (jQuery('input#pricing_switch').is(':checked')) {
      setClassForYearly();
      priceYearly();
    } else {
      setClassForMonthly();
      priceMonthly();
    }
  });

  var checkBox = jQuery('input#pricing_switch');
  jQuery('.pricing-monthly').on('click', function () {
    if (checkBox.attr('checked')) {
      setClassForMonthly();
      checkBox.prop('checked', false);
      priceMonthly();
    }
  });
  jQuery('.pricing-yearly').on('click', function () {
    setClassForYearly();
    if (!checkBox.attr(':checked')) {
      checkBox.prop('checked', true);
      priceYearly();
    }
  });
  window.odometerOptions = {
    duration: 500
  };
  /*
  * Additional asset card funcationality defines here.
  * Based on the select in mobile & range slider in tablet,
  * desktop and json data we are going to updating additional
  * asset cost in the card.
  */
  /*
  * range slider tooltip update function defined below.
  */
  function rsToolTip (currentLocation, start, end) {
    const rsEachColumn = (end - start) / 10;
    if (start === 20000 && end === 20000) {
      jQuery('#rs_tooltip_value').html(start + '+');
    } else {
      jQuery('#rs_tooltip_value').html(start + (rsEachColumn * currentLocation));
    }
  }
  function additionalAsseetCostCard () {
    if (jsonData[selectedCountry].hasOwnProperty('additional_assets_cost')) {
      const assetCost = jsonData[selectedCountry]['additional_assets_cost'];
      /*
      * setting default price
      */
      const assetCostOdometers = jQuery('#asset_cost_odometer');
      assetCostOdometers.text(assetCost['upto_100'][2]);
      jQuery('.range-slider').on('input change', '#input_range', function () {
        const inputRangeValue = jQuery(this).val();
        // we're dividing 100 divisions into 90 parts
        const rsLine = 100 / jQuery('#input_range').attr('max');
        /* range slider line value */
        jQuery('#rs_line').css('width', (inputRangeValue * rsLine) + '%');
        setTimeout(function () {
          const index = Math.ceil(inputRangeValue / 10) - 1;
          let key = jQuery(jQuery('.rs-assets-list li')[index + 1]).find('span').html();
          key = key === 'Unlimited' ? 'unlimited' : `upto_${parseInt(key, 10)}`;
          rsToolTip(inputRangeValue % 10 === 0 ? 10 : inputRangeValue % 10, assetCost[key][0], assetCost[key][1]);
          assetCostOdometers.text(assetCost[key][2]);
          /*
          * to update upto message after price and per month text.
          */
          if (assetCost[key][0] === 20000) {
            jQuery('#rs_upto_text').html('Over');
            jQuery('#rs_upto_value').html('20000+');
          } else {
            jQuery('#rs_upto_text').html('Upto');
            jQuery('#rs_upto_value').html(assetCost[key][1]);
          }
        }, 300);
      });
      // mobile version dropdown
      jQuery('#select-assets-cost').change(function () {
        assetCostOdometers.text(assetCost[jQuery(this).val()][2]);
      });
    }
  }

  const formatCurrency = (value, unit = '') => {
    const regex = unit === 'IN' ? /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g : /(\d)(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(regex, '$1,');
  };
};

/**
 * setLocationBasedCMSPricing show the plan info based on
 * className should follow name convention as follows
 * if className === 'plan' then wrapper className should be 'plan-wrapper'
 * and plan className should be 'plan'
 */

const setLocationBasedCMSPricing = (className, countryCode, countryName) => {
  const $wrapper = $(`.${className}-wrapper`);
  $.each($wrapper, function (index, item) {
    const $plans = $(item).find('.' + className);
    if ($plans.length > 1) {
      const currencies = {};
      $.each($plans, function (index, elem) {
        const currency = $(elem).data('currency');
        currencies[currency] = currency;
      });
      const selectedCountry = SiteUtilities.selectCountry(currencies, countryCode, countryName);
      $plans.addClass('hide');
      $(item).find(`[data-currency='${selectedCountry}']`).removeClass('hide');
    }
  });
};

export default { pricingData, setLocationBasedCMSPricing };
